// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const academicClient = createTypedClient();
export const createAcademicClient = (config) => createTypedClient(config);
